/**
 * Enums for contract management
 */

export enum ProductType {
  MRI = "MRI",
  GLI = "GLI",
  CBNO = "CBNO",
  CHO = "CHO",
}

export enum QuoteStatus {
  DRAFT = "E",                // Draft
  CANCELLED = "AB",           // Cancelled
}

export enum SignatureStatus {
  TO_SIGN = "ASIGNER",
  WAITING_SIGNATURE = "ATTSIGNATURE",
  SIGNED = "SIGNE",
}

export enum DocumentType {
  CONTRACT = "Contrat",
  MANDATE = "mandat",
}

export enum SideMenuType {
  RISK = "risque",
  SUBSCRIBER = "souscripteur",
  TENANT = "locataire",
  CONDITIONS = "conditions",
  CONTRACT = "Contrat",
  MANDATE = "mandat",
}

export enum CompletionStatus {
  COMPLETED = "completed",
  MISSING_PARTS = "missingParts",
}

export enum ContractStatus {
  MissingParts = "missingParts",
  ToSend = "toSend",
  Completed = "completed",
  Pending = "Pending",
  DocToSend = "docToSend",
  ToComplete = "toComplete",
  AENVOYER = "AENVOYER",
  ENVOYER = "ENVOYER",
  TO_SIGN = "ASIGNER",
  WAITING_SIGNATURE = "ATTSIGNATURE",
  SIGNED = "SIGNE",
}
